import { gql } from "@apollo/client"

const GET_LATEST_IMPORT = gql`
  query($id: ID) {
    client(id: $id) {
      id
      
      importType {
        id
        name
        code
      }
      
      latestImport {
        id
        created_at
        status {
          id
          description
          code
        }
      }
    }
  }
`

export { GET_LATEST_IMPORT }
